module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAUtJREFUKBV90k8rRFEYgPE5l1hM0iyUvykllIWVyEewZGdnVjZiy4ovQDZK8QXmS1gONTtliiSRsr3ZzC3X81z36mJy6jf3PefcM+ec976h8qulaRoxNIARGL8gDiF88OzeWFTDIW7RQYI2DlArrwpFh4lF4lM8o4Niroe4F0PYZudrnl/Nf0MTexhGCys5Y8f2YZztHBF4jx284QLTGMdkztixc3jfXdcEfgbpXKGNCfhiFS14zAW8wys8YB5LFRbOwSQ04PE2cAmPL2PHnPMdkzbrMdMSwqyZjKKVY8dM2vdRm3RuMIX/jvrE/AyW3TFGA31YxTq80xn8PMZrcM7dfTeO8oo4ouNOm7iDiXjMGd+jDr/lsWuKj2ySLIAT+FkSlEusn/4Ytn4UAANZY7FZtLwsswRm0PKzDLuXXGmx97bIR2HGX/GnyD8B2jnfNlpgBnMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/detail_search.png
// module id = eruC
// module chunks = 265